<template>
  <b-form-group>
    <h6 class="mb-1 font-size-md">
      <span
        v-if="required"
        class="text-danger ml-n1"
      >*</span>
      {{ $t("global.name") }}
    </h6>
    <b-form-input
      v-model="currentAnswer"
      class="w-100"
      :placeholder="$t('global.please-enter') + $t('global.name')"
      type="text"
      maxlength="10"
      :state="validateState"
    />
    <b-form-invalid-feedback :state="validateState">
      {{
        $t("global.please-enter-required")
      }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  props: {
    answer: {
      type: String,
    },
    required: {
      type: Boolean,
    },
  },
  data() {
    return {
      validateState: undefined,
    };
  },
  computed: {
    currentAnswer: {
      get() {
        return this.answer;
      },
      set(value) {
        this.$emit('update:answer', value);
      },
    },
  },
  watch: {
    currentAnswer() {
      this.validate();
    },
  },
  methods: {
    validate() {
      if (this.required) {
        if (!this.currentAnswer) {
          this.validateState = false;
          return false;
        }
      }
      this.validateState = true;
      return true;
    },
  },
};
</script>
